import Qs from 'qs';

const { fetch } = global

export const fetchCart = () => fetch('/cart.json')

export const getProductsFromRuleset = (rulesetId) =>
  fetch(`https://rebuyengine.com/api/v1/custom/id/${rulesetId}?key=79af9ccb5e4c774262a85d05a8efe0b0f7d06ff0`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
    }
  }).then(response => response.json())
